// ────────────────────────────────────────────────────────────
// Shared job status helpers — used by shop portal + everywhere
// pills render across the app. Keep colors and labels consistent.
// ────────────────────────────────────────────────────────────

export function statusLabel(s) {
  if (!s) return '';
  // Custom pretty labels for statuses that don't title-case well
  const CUSTOM = {
    awaiting_production: 'Awaiting Production',
    in_production:       'In Production',
    ready_to_install:    'Ready to Install',
    contract_signed:     'Contract Signed',
  };
  if (CUSTOM[s]) return CUSTOM[s];
  return String(s).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

// Warm palette — same family used across JobApprovalModal / JobDetailView / the
// Estimates flow. Five tones cover ten statuses by shared meaning: OCHRE = queued
// / pending, WALNUT = actively moving, MOSS = done / good, RUST = held / blocked,
// STONE = idle / inactive.
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';

export function statusColor(s) {
  switch (s) {
    case 'sold':                 return OCHRE;  // freshly sold, queued for a contract
    case 'contract_signed':      return OCHRE;  // contract inked, queued for shop
    case 'awaiting_production':  return OCHRE;  // queued for shop
    case 'in_production':        return WALNUT; // actively building
    case 'completed':            return MOSS;   // shop finished
    case 'ready_to_install':     return MOSS;   // ready to ship
    case 'scheduled':            return WALNUT; // install scheduled
    case 'installed':            return MOSS;   // install done
    case 'on_hold':              return RUST;   // held
    case 'cancelled':            return STONE;  // dead
    default:                     return STONE;  // fallback
  }
}

// Statuses that can be assigned onto the calendar (Assign Job sheet and the
// calendar's Unscheduled panel share this list).
export const ASSIGNABLE_STATUSES = ['in_production', 'ready_for_install', 'on_hold'];
export function isAssignable(job) {
  return ASSIGNABLE_STATUSES.includes(job?.status);
}
